import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsCloudcannonComponent } from './simple-icons-cloudcannon.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsCloudcannonComponent ],
    exports:      [ SimpleIconsCloudcannonComponent ],
    bootstrap:    []
})
export class SimpleIconsCloudcannonModule {}
